import axios from "axios";
import { handleLocal, isLocalMode } from "@/lib/localStore";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const axiosInstance = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Endpoints that MUST hit the real server even in local mode (auth for sign-in/sign-up).
const SERVER_ONLY = ["/auth/login", "/auth/register", "/auth/forgot-password", "/auth/reset-password", "/import/bulk", "/export/pdf-anonymous"];

function goServer(url) {
  return SERVER_ONLY.some((p) => url.startsWith(p));
}

function csvExportLocal() {
  // Built client-side from the local store; matches server CSV columns.
  const { transactions, user } = require("@/lib/localStore").exportLocalData();
  const rows = [["Date","Type","Category","Amount","Note","Currency"]];
  const currency = user?.currency || "USD";
  for (const t of transactions.slice().sort((a,b) => (a.date < b.date ? -1 : 1))) {
    rows.push([
      t.date,
      t.type === "in" ? "Money In" : "Money Out",
      t.category,
      Number(t.amount).toFixed(2),
      (t.note || "").replace(/"/g, '""'),
      currency,
    ]);
  }
  const csv = rows.map((r) => r.map((c) => /[",\n]/.test(String(c)) ? `"${c}"` : String(c)).join(",")).join("\n");
  return new Blob([csv], { type: "text/csv" });
}

async function proxy(method, url, body, cfg) {
  const isCsvExport = url.startsWith("/export/csv");
  if (isLocalMode() && !goServer(url)) {
    if (isCsvExport && method === "get") {
      return { data: csvExportLocal() };
    }
    return handleLocal(method, url, body);
  }
  const args = cfg ? [url, cfg] : [url];
  if (["post", "put", "patch"].includes(method)) {
    return axiosInstance[method](url, body, cfg);
  }
  return axiosInstance[method](...args);
}

export const api = {
  get:    (url, cfg)       => proxy("get",    url, null, cfg),
  post:   (url, body, cfg) => proxy("post",   url, body, cfg),
  put:    (url, body, cfg) => proxy("put",    url, body, cfg),
  patch:  (url, body, cfg) => proxy("patch",  url, body, cfg),
  delete: (url, cfg)       => proxy("delete", url, null, cfg),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
